import { useCallback } from 'react';

import { removeSession } from 'lib/storage';
import { api, setToken } from 'lib/api';
import useStoreDispatch from 'store/useStoreDispatch';

import { logout as logoutDispatch } from 'store/reducers/session';

function useLogout() {
	const dispatch = useStoreDispatch();

	const logout = useCallback(async () => {
		try {
			await api.post('/auth/logout');
		} catch (error) {
			console.warn(error);
		} finally {
			setToken(null);
			dispatch(logoutDispatch());
			removeSession();
		}
	}, [dispatch]);

	return logout;
}

export default useLogout;
